import React from "react";
import "./terms.css";


export default function TermsConditions() {
  return (
    <div>
  

      <div className="terms-container">
        <h1>Terms and conditions</h1>
  



    <h2>1. Introduction</h2>
 
      <p>
        Welcome to <strong>.com</strong> ("Website"), including its
        mobile version and application (collectively referred to as the
        “Website”). This Website is owned, operated, and managed by
        <strong> brand name Foods</strong>, having its registered office at
        <strong> Noida</strong> and principal place of business at
        <strong> USA</strong> (hereinafter referred to as “brand name Foods”,
        “we”, “us” or “our”).
      </p>

      <p>
        By accessing or using this Website, you agree to be bound by these
        Terms and Conditions (“User Agreement”). This agreement remains valid
        for an indefinite period.
      </p>

      <p>
        If you do not agree with any part of this User Agreement, please
        discontinue using this Website immediately.
      </p>

      <p>
        For any queries, feedback, or complaints regarding these Terms, please
        contact us at:
      </p>

      <p>
        <strong>Email:</strong>
        <a href="mailto:Social@.com">
          Social@.com
        </a>
        <br />
        <strong>Customer Support:</strong> +1 000000000
      </p>

      <h3>Ownership of Rights</h3>
      <p>
        All content displayed on this Website including text, images,
        graphics, logos, videos, and software is protected under copyright and
        intellectual property laws.
      </p>
      <p>
        Any copying, storing, reproducing, modifying, distributing, publishing,
        transmitting, selling, or commercial use of Website content without
        written permission is strictly prohibited.
      </p>

      <h3>Accuracy of Content & Invitation to Offer</h3>
      <ul>
        <li>Product images are for representation purposes only</li>
        <li>Packaging may differ</li>
        <li>Weights and measurements are approximate</li>
        <li>Colors may vary based on device display</li>
      </ul>

      <p>
        All products and services listed constitute an invitation to offer, not
        a binding contract. Acceptance occurs only after dispatch confirmation.
      </p>

      <ul>
        <li>Accept or reject any order</li>
        <li>Cancel partial or full orders</li>
        <li>Change product prices</li>
        <li>Modify product descriptions</li>
      </ul>

      <h3>General Terms of Use</h3>
      <ul>
        <li>Use only for lawful purposes</li>
        <li>Comply with all applicable laws</li>
        <li>Not misuse or exploit content</li>
        <li>Not attempt hacking, fraud, or manipulation</li>
        <li>Not engage in misleading or abusive conduct</li>
      </ul>

      <h3>Product Authenticity</h3>
      <p>
        All products sold are 100% genuine. Sellers are contractually bound to
        list only authentic products.
      </p>

      <h3>Order Cancellation Policy</h3>
      <h4>Cancellation by Company</h4>
      <ul>
        <li>Stock unavailability</li>
        <li>Pricing errors</li>
        <li>Fraud detection</li>
        <li>Technical issues</li>
        <li>Payment failures</li>
      </ul>

      <h4>Cancellation by Customer</h4>
      <ul>
        <li>One cancellation allowed per 24 hours</li>
        <li>Orders already processed cannot be cancelled</li>
        <li>Decision of company is final</li>
      </ul>

      <h3>Limitation of Liability</h3>
      <ul>
        <li>Replacement</li>
        <li>Refund equivalent to order value</li>
      </ul>

      <h3>Jurisdiction</h3>
      <p>
        All disputes shall be governed by Indian laws and subject to courts in
        New Delhi, India only.
      </p>

      <h3>Usage Restrictions</h3>
      <ul>
        <li>Upload illegal content</li>
        <li>Spread hate or abuse</li>
        <li>Infringe copyrights</li>
        <li>Share malware</li>
        <li>Impersonate others</li>
        <li>Disrupt platform operations</li>
      </ul>


 <h2>Quantity Restrictions</h2>
      <p>We reserve the right to:</p>
      <ul>
        <li>Limit order quantities</li>
        <li>Cancel suspicious bulk purchases</li>
        <li>Restrict high-volume orders</li>
      </ul>

      <h2>Pricing Information</h2>
      <p>Prices may change without notice. Errors may occur and we reserve the right to:</p>
      <ul>
        <li>Cancel mispriced orders</li>
        <li>Contact users for correction</li>
        <li>Refund payments</li>
      </ul>

      <h2>Indemnity</h2>
      <p>You agree to indemnify brand name Foods from any claims arising from:</p>
      <ul>
        <li>Misuse of Website</li>
        <li>Legal violations</li>
        <li>False information</li>
        <li>Fraud</li>
        <li>IP infringement</li>
      </ul>

      <h2>Eligibility</h2>
      <p>
        Only users legally eligible to contract under Indian law may use this Website.
        Minors and banned users are not permitted.
      </p>

      <h2>Privacy</h2>
      <p>If you do not agree, please stop using this Website.</p>
      <p>We collect limited user data including:</p>
      <ul>
        <li>IP address</li>
        <li>Device information</li>
        <li>Browser type</li>
        <li>Usage patterns</li>
      </ul>

      <p>Cookies may be used for:</p>
      <ul>
        <li>Technical administration</li>
        <li>User experience optimization</li>
        <li>Research</li>
      </ul>

      <p>We do NOT store sensitive card details.</p>

      <h2>Third-Party Ads</h2>
      <p>
        We may display ads from third-party vendors.
        We do NOT share personally identifiable data.
      </p>

      <h3>Call Recording</h3>
      <p>Customer calls may be recorded for:</p>
      <ul>
        <li>Training</li>
        <li>Quality control</li>
        <li>Service improvement</li>
      </ul>

      <h2>Data Security</h2>
      <p>We use:</p>
      <ul>
        <li>SSL encryption</li>
        <li>Firewalls</li>
        <li>Secure servers</li>
      </ul>
      <p>We are not responsible for third-party payment gateway breaches.</p>

      <h2>Promotional Communication</h2>
      <p>We may send:</p>
      <ul>
        <li>Emails</li>
        <li>SMS</li>
        <li>Offers</li>
      </ul>
      <p>You may opt out anytime.</p>

      <h3>Financial Information</h3>
      <p>You confirm:</p>
      <ul>
        <li>You own the payment method used</li>
        <li>No fraudulent usage</li>
        <li>Bank handles transactions</li>
      </ul>

      <h3>Communication Consent</h3>
      <p>By using our site, you consent to electronic communication.</p>

      <h3>User Content</h3>
      <p>All reviews and feedback become our property. We may use them for:</p>
      <ul>
        <li>Marketing</li>
        <li>Display</li>
        <li>Modification</li>
      </ul>
      <p>No compensation owed.</p>

      <h3>Copyright & Trademark</h3>
      <p>All trademarks belong to respective owners. Unauthorized use is prohibited.</p>

      <h3>Objectionable Content</h3>
      <p>You may encounter content you dislike. Use at your own discretion.</p>

      <h3>Termination</h3>
      <p>We may terminate access anytime without notice.</p>

      <h3>Disclaimer</h3>
      <p>
        Website provided "AS IS". No warranties implied.
        Use at your own risk.
      </p>

      <h3>Health Disclaimer</h3>
      <p>
        Information is for educational purposes only.
        Not a substitute for medical advice.
        Consult doctor before supplement use.
      </p>

      <h3>COVID Disclaimer</h3>
      <p>
        Nutrition advice does not replace medical care.
        No guarantee of prevention.
      </p>






<h2>2. REFUSAL OF SERVICE</h2>

<p>We reserve the right to refuse service to anyone at any time without prior notice.</p>

<p>Service may be suspended due to:</p>

<ul>
  <li>Technical failures</li>
  <li>Security threats</li>
  <li>Fraud detection</li>
  <li>System abuse</li>
  <li>Policy violation</li>
</ul>

<p>We are not liable for any losses caused due to service interruption.</p>

<h2>3. PROMOTIONAL COMMUNICATIONS</h2>

<p>We may send you:</p>

<ul>
  <li>Promotional emails</li>
  <li>SMS updates</li>
  <li>Offer notifications</li>
  <li>Product announcements</li>
</ul>

<p>You may unsubscribe anytime using the link provided or contact customer support.</p>
<p>Unsubscription processing time: <strong>7 working days</strong></p>

<h2>4. INTELLECTUAL PROPERTY RIGHTS</h2>

<p>All Website content including:</p>

<ul>
  <li>Text</li>
  <li>Logos</li>
  <li>Images</li>
  <li>Layouts</li>
  <li>Design</li>
  <li>Code</li>
</ul>

<p>are protected under copyright laws.</p>

<p>Unauthorized usage including:</p>

<ul>
  <li>Reproduction</li>
  <li>Distribution</li>
  <li>Republishing</li>
  <li>Commercial use</li>
</ul>

<p>is strictly prohibited.</p>

<p>C2C Supplements, brand name Foods, and all listed brands remain property of respective owners.</p>

<h2>5. THIRD PARTY LINKS</h2>

<p>We may display external website links. We are NOT responsible for:</p>

<ul>
  <li>Their content</li>
  <li>Privacy policies</li>
  <li>Data usage</li>
</ul>

<p>Use at your own discretion.</p>

<h2>6. TERMINATION OF AGREEMENT</h2>

<p>This agreement remains effective until terminated.</p>

<p>Termination may occur:</p>

<ul>
  <li>By user – stop using website</li>
  <li>By us – without notice</li>
</ul>

<p>Upon termination:</p>

<ul>
  <li>Access will be revoked</li>
  <li>Downloaded materials must be destroyed</li>
</ul>

<h2>7. LIMITATION OF LIABILITY</h2>

<p>We are not liable for:</p>

<ul>
  <li>Indirect losses</li>
  <li>Business losses</li>
  <li>Data loss</li>
  <li>System failure</li>
  <li>External attacks</li>
</ul>

<p>Maximum liability is limited to order value only.</p>

<h2>8. IMAGE DISCLAIMER</h2>

<p>Images displayed are for reference only. We do not guarantee exact match.</p>

<h2>9. DATA PROTECTION</h2>

<p>We maintain:</p>

<ul>
  <li>Secure servers</li>
  <li>Encrypted transactions</li>
  <li>Limited data storage</li>
</ul>

<p>We DO NOT store:</p>

<ul>
  <li>Card numbers</li>
  <li>CVV</li>
  <li>Banking details</li>
</ul>

<h2>10. ARBITRATION CLAUSE</h2>

<p>All disputes shall be resolved through arbitration:</p>

<ul>
  <li>Location: New Delhi</li>
  <li>Language: English</li>
  <li>Single arbitrator appointed by C2C Supplements</li>
  <li>As per Arbitration Act 1996</li>
</ul>

<h2>11. GOVERNING LAW</h2>

<p>These terms are governed by Indian Law.</p>
<p>Courts jurisdiction: New Delhi only</p>

<h2>12. ENTIRE AGREEMENT</h2>

<p>This document constitutes full agreement between:</p>

<ul>
  <li>User</li>
  <li>C2C Supplements</li>
</ul>

<p>Supersedes all prior agreements.</p>

<h2>13. MODIFICATIONS</h2>

<p>We reserve rights to:</p>

<ul>
  <li>Modify</li>
  <li>Update</li>
  <li>Remove sections</li>
</ul>

<p>without prior notice.</p>

      <h2>14. WEBSITE SECURITY</h2>

<p>You are strictly prohibited from attempting to violate or breach the security of the Website, including but not limited to:</p>

<ul>
  <li>Accessing data not intended for you</li>
  <li>Logging into accounts without authorization</li>
  <li>Probing, scanning, or testing vulnerabilities</li>
  <li>Submitting viruses or malware</li>
  <li>Overloading servers</li>
  <li>Spamming or flooding</li>
  <li>Forging headers</li>
  <li>Attempting to crash systems</li>
</ul>

<p>Any violation may lead to civil and criminal action. brand name Foods reserves the right to cooperate with law enforcement authorities in such cases.</p>

<p>You agree not to use:</p>

<ul>
  <li>Automated bots</li>
  <li>Scrapers</li>
  <li>Crawlers</li>
  <li>Unauthorized software tools</li>
</ul>

<p>to access, copy, or manipulate Website content.</p>

<h2>15. HEALTH DISCLAIMER</h2>

<p>Information provided is:</p>

<ul>
  <li>Educational only</li>
  <li>Not medical advice</li>
</ul>

<p>Consult doctor before supplement use.</p>
<p>Results vary from person to person.</p>

<h2>16. COVID DISCLAIMER</h2>

<p>Nutrition advice does not guarantee prevention. Consult medical professional if infected.</p>

<h2>17.FINAL NOTE</h2>
<p>By using Erathmaa Foods, you acknowledge that you:</p>


<p>✔ Read these terms</p>
<p>✔ Understood them</p>

<p>✔ Agree to be bound</p>

        <h2>18. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us:</p>
        <p>
          <strong>Email:</strong> social@.com
        </p>
        <p>
          <strong>Phone:</strong> +1 000000000
        </p>
        
      </div>


      

     
    </div>
  );
}
